import ChooseAvatar from "./ChooseAvatar"

export default ChooseAvatar
